import React, { Component, Fragment } from 'react';
import axios from 'axios';

import VideoPopup from '../components/VideoPopup';
import Header from '../components/Header';

class Estrutura extends Component {
  state = {
    allVideos: null,
    isLoading: false,
    error: [],
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    axios
      .get('https://www.acertarorumo.pt/wp-json/wp/v2/posts?categories=8')
      .then((response) => {
        this.setState({
          isLoading: false,
          allVideos: response.data.reverse(),
        });
      })
      .catch((error) =>
        this.setState({
          error: error,
          isLoading: false,
        })
      );
  }

  render() {
    const { allVideos, isLoading } = this.state;

    // console.log(allVideos);

    let videos =
      allVideos !== null && isLoading === false ? (
        allVideos.map((video) => (
          <VideoPopup
            key={video.id}
            img={video.content.rendered}
            name={video.title.rendered}
            iframe={
              <iframe
                title={video.title.rendered}
                src={video.video_url}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            }
          />
        ))
      ) : (
        <p>A carregar...</p>
      );

    return (
      <Fragment>
        <Header title={'Vídeos'} />

        <section className="content">
          <div className="column video-grid">{videos}</div>
        </section>
      </Fragment>
    );
  }
}

export default Estrutura;
